import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCircle12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconCircle12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Circle12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10m0 1A6 6 0 1 0 6 0a6 6 0 0 0 0 12"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Circle12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconCircle12);
